import { useEffect } from 'react';

export const useTimeToMount = (callback: (time: number) => void) => {
  const started = performance.now();
  useEffect(() => {
    callback(performance.now() - started);
  }, []);
};
